import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy, Inject
} from '@angular/core';

require('./expand-button.scss');
@Component({
  standalone: false,
  selector: 'app-expand-button',
  templateUrl: './expand-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExpandButtonComponent {
  @Input() isExpanded: boolean;
  @Input() tooltipText: string;
  @Input() isMobile: boolean;
  @Output() onToggle = new EventEmitter<void>();

  constructor(@Inject('$timeout') private $timeout) {}

  toggle(): void {
    this.onToggle.emit();
    this.$timeout(0).then(() => {});
  }
}
